import { Alert, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { TitledContainer } from '../../../../components/TitledContainer/TitledContainer';
import { formatFullDriverName } from '../../../../core-module/helpers/nameFormatting';
import { hasRole, RoleTypes } from '../../../../core-module/helpers/RoleHelper';
import { loopBackApi } from '../../../../core-module/models/LoopBack/Api/LoopBackApi';
import { useTypedSelector } from '../../../../core-module/redux';
import { Driver } from '../../../../core-module/types';
import { AbsenceOverviewContainer } from './AbsenceOverviewContainer';
import { DriverSelector } from './DriverSelector';
import { ReplacementOverviewContainer } from './ReplacementOverviewContainer';

const AbsencePage: React.FC = () => {
  useEffect(() => {
    document.title = 'Logistics | Afwezigheid';
  }, []);

  const driverId = useTypedSelector((state) => state.auth.user.driver!.id);
  const roles = useTypedSelector((state) => state.auth.roles);
  let isDepotAdmin = hasRole(roles, RoleTypes.DEPOT_ADMIN);

  const [selectedDriverId, setSelectedDriverId] = useState(driverId);
  const [drivers, setDrivers] = useState<Driver[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = 'Logistics | Afwezigheid';
  }, []);

  useEffect(() => {
    if (isDepotAdmin) {
      loopBackApi()
        .get<Driver[]>('drivers/from-depot')
        .then((response) => {
          setDrivers(response.data || []);
        })
        .catch(() =>
          Swal({
            title: 'Er is iets misgegaan',
            html: 'Het laden van bezorgers is mislukt',
            type: 'error',
            confirmButtonText: 'Ok'
          })
        )
        .finally(() => setLoading(false));
    }
  }, [isDepotAdmin]);

  const driverSelectItems = [{ id: driverId, name: 'Eigen afwezigheid' }].concat(
    drivers.map((driver) => ({
      id: driver.id,
      name: formatFullDriverName(driver)
    }))
  );

  const handleDriverSelect = (driverId: number) => {
    setSelectedDriverId(driverId);
  };

  return (
    <>
      <ReplacementOverviewContainer />
      <TitledContainer title='Afwezigheid'>
        <Row>
          <Alert
            style={{ marginBottom: '10px' }}
            message='Let op! Controleer of het logistieke team al een vervanger heeft gevonden via "Routes" en de betreffende dag.'
          />
        </Row>
        {isDepotAdmin && (
          <Row>
            <DriverSelector
              loading={loading}
              drivers={driverSelectItems}
              defaultValue={selectedDriverId}
              onSelect={handleDriverSelect}
            />
          </Row>
        )}
        <AbsenceOverviewContainer key={selectedDriverId} driverId={selectedDriverId} />
      </TitledContainer>
    </>
  );
};

export { AbsencePage };
